/**
 * Converts html entities like &nbsp;
 */
export const htmlDecode = (input: string): string => {
  // eslint-disable-next-line unicorn/prevent-abbreviations
  const doc = new DOMParser().parseFromString(input, 'text/html');
  return doc.documentElement.textContent || '';
};
